<template>
    <Slide :title="title" :subtitle="subtitle">
        <div>
            <p>You’re all set to explore the tools and features available in your company dashboard. From here, you can manage your company details, set up campaigns, add
                billing information, access reports, and take advantage of our full suite of features designed to support your business.</p>
            <p class="cr:pt-2">
                If you need any assistance or have questions about your account, our support team is always here to help.
            </p>
            <div class="cr:mt-2">
                <p>Phone: <a :href="`tel: ${configStore.supportPhone}`" class="cr:text-blue-500 cr:cursor-pointer">{{ configStore.supportPhone }}</a></p>
                <p>Email: <a :href="`mailto: ${configStore.supportPhone}`" class="cr:text-blue-500 cr:cursor-pointer">{{ configStore.supportEmail }}</a></p>
            </div>
            <p class="cr:pt-2">
                Thank you for joining us. We’re excited to have you on board and look forward to helping you grow your business.
            </p>
        </div>
    </Slide>
</template>

<script setup lang="ts">

import {useConfigStore} from "@/stores/config.ts";
import Slide from "@/components/slides/Slide.vue";
import CustomButton from "@/components/elements/CustomButton.vue";
import {computed, onBeforeMount, ref} from "vue";
import {useRegistrationStore} from "@/stores/registration.ts";
import {useErrorStore} from "@/stores/error.ts";
import {ORIGINS} from "@/services/ConstantSerice.ts";

const configStore = useConfigStore();
const registrationStore = useRegistrationStore();
const errorStore = useErrorStore();
const dashboardLoginToken = ref('');
const loginButtonDisabled = ref(true);

const props = defineProps({
    title: {
        type: String,
        default: 'Registration Completed'
    },
    subtitle: {
        type: String,
        default: 'Your company account has been successfully registered.'
    }
});

onBeforeMount(async () => {
    // if (registrationStore.registeringCompany.userReference) {
    //     await registrationStore.apiService.getDashboardLoginToken(registrationStore.registeringCompany.userReference)
    //         .then(resp => dashboardLoginToken.value = resp.data.data.token)
    //         .catch(e => {
    //             errorStore.report('Something went wrong. Please try again');
    //             console.error(e);
    //         });
    // }

    loginButtonDisabled.value = false;
});

const calendlyLink = computed(() => {
    switch (registrationStore.registrationOrigin?.toLowerCase()) {
        case ORIGINS.HM:
            return 'https://calendly.com/brian-solarreviews';
        default:
            return 'https://calendly.com/account-manager-calander/solarreviews-com-intro'
    }
})

const scheduleDemo = () => {
  // @ts-ignore
  if (window.Calendly !== 'undefined') {
    // @ts-ignore
    window.Calendly.initInlineWidget({url: calendlyLink.value});
  }
  return false;
}

const loginToDashboard = () => {
    if (dashboardLoginToken.value) {
        window.open(`${configStore.dashboardUrl}/login-with-token?token=${dashboardLoginToken.value}`, '_blank');
        return;
    }

    window.open(configStore.dashboardUrl, '_blank');
}

</script>